const hasOwnProp = Object.prototype.hasOwnProperty;
const brands = {
  IPHONE: 'IPHONE|IPAD|IPOD|IOS',
  OPPO: 'OPPO',
  VIVO: 'VIVO',
  HONOR: 'HONOR',
  HUAWEI: 'HUAWEI',
  XIAOMI: 'XIAOMI|REDMI',
  360: '1801-A01|1707-A01|1509-A00',
  SAMSUNG: 'SAMSUNG',
};
const userAgent = window.navigator.userAgent.toUpperCase();
const isWeixin = !!userAgent.match(/MicroMessenger/i);
const isDingtalk = !!userAgent.match(/DingTalk/i);

Object.keys(brands).forEach((key) => {
  if (hasOwnProp.call(brands, key)) {
    brands[key] = new RegExp(brands[key], 'i');
  }
});

const OSMap = {
  ANDROID: '1',
  IOS: '2',
};

/**
 * 获取系统名称，安卓或者ios
 */
function getOS() {
  if (userAgent.indexOf('ANDROID') > -1) {
    return OSMap.ANDROID;
  }
  if (userAgent.indexOf('IPHONE') > -1) {
    return OSMap.IOS;
  }
  return null;
}

/**
 * 获取设备品牌
 */
function getBrand() {
  const result = [];
  Object.keys(brands).forEach((key) => {
    if (hasOwnProp.call(brands, key)) {
      if (brands[key].test(userAgent)) {
        result.push(key);
      }
    }
  });
  return result[0];
}
const os = getOS();
const brand = getBrand();

function getStoreUrl() {
  if (os === OSMap.IOS) {
    return 'https://itunes.apple.com/cn/app/id1527362440?mt=8';
  }
  let url = '';
  const apkPackageName = 'com.emodor.emodor2c';
  switch (brand) {
    case 'HONOR':
      url = `intent://details?id=${apkPackageName}#Intent;package=com.huawei.appmarket;scheme=market;end;`;
      break;
    case 'HUAWEI':
    case 'OPPO':
      url = `market://details?id=${apkPackageName}`;
      break;
    case 'XIAOMI':
      url = `intent://details?id=${apkPackageName}#Intent;package=com.xiaomi.market;scheme=market;end;`;
      break;
    case 'VIVO':
      url = `intent://details?id=${apkPackageName}#Intent;package=com.bbk.appstore;scheme=market;end;`;
      break;
    case 'SAMSUNG':
      url = `http://www.samsungapps.com/appquery/appDetail.as?appId=${apkPackageName}`;
      break;
    case '360':
      url = `intent://details?id=${apkPackageName}#Intent;package=com.qihoo.appstore;scheme=market;end;`;
      break;
    default:
      // url = `https://a.app.qq.com/o/simple.jsp?pkgname=${apkPackageName}`;
      break;
  }
  return url;
}

const isIOS = os === OSMap.IOS;

export {
  isWeixin,
  isDingtalk,
  isIOS,
  getStoreUrl,
};
